import {  ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { finalize } from 'rxjs';
import Currencies from 'src/assets/data/currencies.json';
import Countries from 'src/assets/data/uob-countries.json';

import { MomentService } from 'src/app/shared/services/moment.service';
@Component({
  selector: 'app-uob-tt',
  templateUrl: './tt.component.html',
  styles: [],
  standalone: false
})
export class UobTtComponent implements OnInit {
  private momentService = inject(MomentService);
  useCrossBorderPayment = window.location.host !== 'account.qne.cloud';
  bankAccs: any[] = [];
  countryOptions: any[] = [];
  currencyOptions: any[] = [];
  private _data: any = {};
  get data(): any {
    return this._data;
  }
  @Input() set data(val: any) {
    this._data = val;

    const formValue: any = {
      payeeName: val.payeeName?.slice(0, 35),
      currency: val.foreign.currency,
      //payeeCurrency: val.foreign.currency,
      amount: val.foreign.amount
      //payForCode: val.payForCode
    };

    this.form.patchValue(formValue);

    // Produce dummy data
    if (this.useCrossBorderPayment) {
      // Update form values with dummy data
      this.form.controls.payeeCountry.setValue('MY');
      this.form.controls.payeeBankCountry.setValue('MY');
      this.form.controls.payeeAddress1.setValue('-');
      this.form.controls.payeeBankAddress.setValue('CIMB Bank Berhad');
      this.form.controls.payeeBankName.setValue('CIMB Bank Berhad');
      this.form.controls.payeeBankBIC.setValue('0000000000');
      this.form.controls.payeeAccount.setValue('0000000000');
      this.form.controls.isResident.setValue(true);
      this.form.controls.isOwnAcc.setValue(true);
      this.form.controls.transferDate.setValue(new Date());
      this.form.controls.paymentDetails.setValue('Cross border payment');
      this.form.controls.payeeRef.setValue('Cross border payment');
    }
  }

  form = this.fb.group({
    account: ['', [Validators.required, Validators.maxLength(30)]],
    accountCurrency: ['', []],
    //payeeCurrency: [{ value: '', disabled: false }, [Validators.required]],
    payeeName: ['', [Validators.required, Validators.maxLength(35)]],
    payeeCountry: ['MY', [Validators.required, Validators.maxLength(2)]],
    payeeAddress1: ['', [Validators.required, Validators.maxLength(35)]],
    payeeAddress2: ['', [Validators.maxLength(35)]],
    payeeAddress3: ['', [Validators.maxLength(35)]],
    payeeBankAddress: ['', [Validators.required, Validators.maxLength(35)]],
    payeeBankCountry: ['MY', [Validators.required, Validators.maxLength(2)]],
    payeeBankBIC: [
      { value: '', disabled: false },
      [Validators.required, Validators.maxLength(11)]
    ],
    payeeAccount: ['', [Validators.required, Validators.maxLength(19)]],
    isResident: [true, [Validators.required]],
    isOwnAcc: [true, [Validators.required]],
    payeeBankName: ['', [Validators.required, Validators.maxLength(35)]],
    transferDate: [new Date(), [Validators.required]],
    currency: ['', [Validators.required]],
    amount: [
      0,
      [
        Validators.required,
        Validators.min(0.01),
        Validators.max(9999999999999.99)
      ]
    ],
    paymentDetails: ['', [Validators.required, Validators.maxLength(140)]],
    payeeRef: ['', [Validators.required, Validators.maxLength(35)]]
  });

  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    this.momentService.moment().diff(current, 'days') > 0;

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private http: _HttpClient
  ) {
    this.form.controls.account.valueChanges.subscribe(val => {
      if (val) {
        const bank = this.bankAccs.find(x => x.bankAccountNo === val);
        if (bank) {
          this.form.controls.accountCurrency.setValue(bank.currencyCode);
        }
      }
    });
  }

  ngOnInit(): void {
    this.countryOptions = Countries.filter(x => x.code).map(x => {
      return { label: x.name, value: x.code };
    });
    this.currencyOptions = Currencies.filter(x => x.code).map(x => {
      return { label: x.code, value: x.code };
    });
    this.loadBankAccounts();
  }

  private loadBankAccounts() {
    let url = `api/accountcodes/search?$top=10&$skip=0&$orderby=code asc`;
    var filter = `IsActive eq true and BankTypeCode eq 'UOB' and BankAccountNo ne null and BankAccountNo ne ''`;
    url = `${url}&$filter=${filter}`;
    this.http
      .get(url)
      .pipe(
        finalize(() => {
          this.cdr.detectChanges();
        })
      )
      .subscribe(res => {
        if (res.value) {
          res.value.forEach((item: any) => {
            item.label = `${item.bankAccountNo} (${item.currencyCode})`;
          });

          this.bankAccs = [...res.value];

          if (this.useCrossBorderPayment) {
            if (this.bankAccs.length > 0) {
              this.form.controls.account.setValue(
                this.bankAccs[0].bankAccountNo
              );
              this.form.controls.accountCurrency.setValue(
                this.bankAccs[0].currencyCode
              );
            } else {
              this.form.controls.account.setValue('0000000000');
              this.form.controls.accountCurrency.setValue('MYR');
            }
          }
        }
      });
  }
}
